import React, { useContext } from 'react';
import { isMobile } from 'react-device-detect';
import { TextField } from '@material-ui/core';
import Button from '../../../../../../components/Button/ProgressiveButton';
import { CategoryContext } from './CategoryProvider';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 500,
    display: 'grid',
    gridTemplateColumns: isMobile ? '1fr 1fr' : '2fr 1fr 1fr',
    gridGap: theme.spacing(1),
  },
}));

const Form = () => {
  const classes = useStyles();
  const {
    selected,
    category,
    changeTextField,
    addCategory,
    editCategory,
    resetForm,
    showError,
    inProgress,
  } = useContext(CategoryContext);

  const handleClick = (e) => {
    if (e) e.preventDefault();
    if (!category) {
      showError('نام نقش را وارد نمایید');
      return;
    }
    if (!selected) {
      addCategory(category);
    } else {
      editCategory(category, selected._id);
    }
  };
  const handleResetForm = () => {
    resetForm();
  };

  return (
    <form className={classes.root} onSubmit={handleClick}>
      <TextField
        value={category || ''}
        onChange={changeTextField}
        variant="outlined"
        size="medium"
        name="category"
      />
      <Button
        onClick={handleClick}
        variant="contained"
        color="secondary"
        size="medium"
        disabled={inProgress}
      >
        {!selected ? 'جدید' : 'ویرایش'}
      </Button>
      {!!selected && (
        <Button
          onClick={handleResetForm}
          variant="outlined"
          color="secondary"
          size="medium"
          disabled={inProgress}
        >
          صرفنظر
        </Button>
      )}
    </form>
  );
};

export default React.memo(Form);
